import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, bibFieldShape } from '@bibliocommons/bc-prop-types';
import { createBibFieldSelector, selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentMovie } from 'app/selectors/MoviesSelector';
import Contributors from './Contributors';

const CATEGORY = 'CONTRIBUTORS';
const FIELD_NAME = 'CONTRIBUTOR_NAME';
const selectContributorNames = createBibFieldSelector(CATEGORY, FIELD_NAME);

export class ContributorsContainer extends React.PureComponent {
  render() {
    const { trackFieldItemClick } = this.props;
    return (
      <Contributors
        {...this.props}
        trackFieldItemClick={(fieldItem, fieldValue) => trackFieldItemClick(CATEGORY, fieldItem, fieldValue)}
      />
    );
  }
}

ContributorsContainer.propTypes = {
  bib: bibShape.isRequired,
  movie: ImmutablePropTypes.map,
  contributorNames: bibFieldShape,
  trackFieldItemClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);

  return {
    bib,
    movie: selectCurrentMovie(state),
    contributorNames: selectContributorNames(state)
  };
};

export default connect(mapStateToProps)(ContributorsContainer);
